<header class="container  is-fluid header" (clickOutside)="clickedOutside()">
    <nav id="montreal-navigation" class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a role="button" class="navbar-burger header__burger"
               (click)="toggleNavbar()"
               aria-label="menu"
               aria-expanded="false">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <div class="navbar-brand header__menu-start">
            <a role="button" class="navbar-item no-hover header__menu-start__a-logo">
                <app-svg-icon [height]="logoSizeHeight"
                              [width]="logoSizeWidth"
                              icon="novo-logo-montreal-invertido"
                              fill="white"
                              [flex]="true"
                              class="header__menu-start--icon__logo">
                </app-svg-icon>
            </a>
            <a role="button" class="button navbar-item no-hover navbar-item no-hover header__menu-start__a-comunity" (click)="goToCommunity()">
                <app-svg-icon icon="persons" class="header__menu-start--icon"></app-svg-icon>
                <span>Comunidade</span>
            </a>
            <a role="button" class="button navbar-item no-hover navbar-item no-hover header__menu-start__a-blog" (click)="goToBlog()">
                <app-svg-icon icon="edit" class="header__menu-start--icon"></app-svg-icon>
                <strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Blog&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
            </a>
        </div>

        <div class="header__menu-center">
            <a class="header__menu-logo">
<!--                <app-svg-icon icon="novo-logo-montreal-invertido" fill="white" class="header__menu-icon"></app-svg-icon>-->
                <img src="/assets/img/view/novo-logo-montreal-invertido.png" alt="montreal-gif">
            </a>
        </div>

        <div class="header__menu-end">
            <div class="buttons">
                <a class="button is-primary header__menu-end__a-comunity" (click)="goToCommunity()">
                    <app-svg-icon icon="persons" class="header__menu-end__a-comunity-icon"></app-svg-icon>
                    <span>Comunidade</span>
                </a>
                <a class="button is-primary" (click)="goToCart()">
                    <strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Assine agora&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
                </a>
            </div>
        </div>

        <aside *ngIf="isOpenFloatMenu && showToggleNavbar" class="header__aside" [@openClose]="isOpenFloatMenu ? 'open' : 'closed'">
            <div class="header__aside--navigation">
                <nav>
                    <ul class="sidebar">
                        <li class="montreal-navigation-item">
                            <a rel="noopener" (click)="toggleNavbar('hotels')">Hotéis</a>
                        </li>
                        <li class="montreal-navigation-item">
                            <a rel="noopener" (click)="toggleNavbar('plans')">Planos</a>
                        </li>
                        <li class="montreal-navigation-item"><a (click)="goTo('indique-e-ganhe', true)">Indique e Ganhe</a></li>
                        <li class="montreal-navigation-item header__aside--navigation-item-mobile"><a (click)="goToBlog()">Blog</a></li>
                        <li class="montreal-navigation-item"><a (click)="goTo('contatos', true)">Contatos</a></li>
                        <li class="header__aside--navigation-menu-dropdown navbar-item">
                            <a class="header__aside--navigation-menu-dropdown__principal">A Montreal <i class="fas fa-chevron-down"></i></a>
                            <ul class="header__aside--navigation-menu-dropdown__dropdown">
                                <li><a (click)="goTo('a-montreal')">Quem somos </a></li>
                                <li>
                                    <a target="_blank" href="https://www.montrealguru.guru/regulamentos-promos/">
                                        Regulamentos
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://www.viagensmontreal.com/site/novoportalhoteleiro/">
                                        Portal do Hoteleiro
                                    </a>
                                </li>
                                <li><a href="https://clubemontreal.empregare.com/pt-br/vagas">Trabalhe Conosco</a></li>
                                <li><a (click)="goTo('politica-privacidade')">Política de Privacidade</a></li>
                                <li class="header__aside--navigation-menu-dropdown__dropdown--menu-dropdown-2">
                                    <a>Parceiro de Negócios <i class="fas fa-chevron-down"></i></a>
                                    <ul class="header__aside--navigation-menu-dropdown__dropdown--dropdown-2">
                                        <li>
                                            <a target="_blank"
                                               href="https://sistemas.montrealonline.com.br/sso/login?service=https%3A%2F%2Fsistemas.montrealonline.com.br%2F%3F_ga%3D2.239077313.352222308.1588614017-amp-IvY2LGLC0RkHvFd6LuRJlg">
                                                Já sou Parceiro
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://www.montrealguru.guru/parceiros-de-negocios/">
                                                Quero ser Parceiro
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://www.montrealguru.guru/lista-parceiros/">
                                                Parceiros Credenciados
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
    </nav>
</header>
